import { render, staticRenderFns } from "./PersonCard.vue?vue&type=template&id=31fb00c8"
import script from "./PersonCard.vue?vue&type=script&lang=js"
export * from "./PersonCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports